import { workerClient } from './api/workerClient';
import { apiEndpoints } from './api/endpoints';

export interface CalculateRequest {
  items: {
    product_id: string;
    quantity: number;
  }[];
  shipping_address?: {
    line1: string;
    line2?: string;
    city: string;
    state: string;
    postal_code: string;
    country: string;
  };
  billing_address?: {
    line1: string;
    line2?: string;
    city: string;
    state: string;
    postal_code: string;
    country: string;
  };
}

export interface CalculateResponseItem {
  product_id: string;
  sku?: string;
  name: string;
  quantity: number;
  unit_price: number;
  tax_amount: number;
  discount_amount: number;
  total_amount: number;
}

export interface CalculateResponse {
  items: CalculateResponseItem[];
  subtotal_amount: number;
  tax_amount: number;
  shipping_amount: number;
  discount_amount: number;
  total_amount: number;
  currency: string;
}

export const checkoutService = {
  calculate: async (request: CalculateRequest): Promise<CalculateResponse> => {
    const response = await workerClient.post(apiEndpoints.checkout.calculate(), request);
    return response.data.data;
  }
};
